import { useWsmBrandNamesQuery } from "@dashboard/graphql";
import { mapEdgesToItems } from "@dashboard/utils/maps";

/**
 * The store's brands, by name: what the series brand picker offers. First 100,
 * which covers every 5.0 store measured so far; a series carries its brand as a
 * string until WSM6-3051 points it at the Brand row, so the picker also takes a
 * name the list does not have.
 */
export const useWsmBrands = () => {
  const { data, loading } = useWsmBrandNamesQuery({ variables: { first: 100 } });

  return { brands: mapEdgesToItems(data?.wsmBrands) ?? [], loading };
};

export default useWsmBrands;
